import { render, staticRenderFns } from "./OtherIncomePaymentList.vue?vue&type=template&id=97e80114"
import script from "./OtherIncomePaymentList.vue?vue&type=script&lang=js"
export * from "./OtherIncomePaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports